import { Cart } from '@ads-bread/shared/bread/codecs';
import { APIFetch, APIResponse } from '../hooks/apiFetch';
import { HandlerResponse, handleResponse } from './base';

export const getCartPublicURI = (cartID: string): string =>
  `/api/cart/${cartID}/public`;

export async function getCartPublic(
  apiFetch: APIFetch,
  cartID: string
): Promise<HandlerResponse<Cart>> {
  const uri = getCartPublicURI(cartID);
  const res: APIResponse<Cart> = await apiFetch<Cart>(
    uri,
    { method: 'GET' },
    Cart
  );
  return handleResponse(res);
}
